import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import axios from 'axios';
import { useSyncRefresh } from '../hooks/useSyncRefresh';

import API from '../utils/api';

var PlanContext = createContext(null);

export function usePlan() {
  return useContext(PlanContext);
}

export function PlanProvider({ children }) {
  var { user } = useAuth();
  var [planData, setPlanData] = useState(null);

  var refresh = useCallback(function () {
    if (!user) { setPlanData(null); return; }
    axios.get(API + '/auth/plan-status', { withCredentials: true })
      .then(function (r) { setPlanData(r.data); })
      .catch(function () {});
  }, [user]);

  useEffect(function () { refresh(); }, [refresh]);
  useSyncRefresh(refresh);

  var plan = (user && user.subscription_plan) || 'free';

  var canAccess = function (featureKey) {
    if (!planData) return true; // loading — allow optimistically
    return !!planData.limits[featureKey];
  };

  var getUsage = function (counterType) {
    if (!planData || !planData.usage[counterType]) return null;
    return planData.usage[counterType];
  };

  var getDiscount = function () {
    if (!planData) return 0;
    return planData.limits.courses_discount || 0;
  };

  var planAtLeast = function (min) {
    var order = ['free', 'basic', 'standard', 'pro'];
    return order.indexOf(plan) >= order.indexOf(min);
  };

  return (
    <PlanContext.Provider value={{ plan: plan, planData: planData, canAccess: canAccess, getUsage: getUsage, getDiscount: getDiscount, planAtLeast: planAtLeast, refresh: refresh }}>
      {children}
    </PlanContext.Provider>
  );
}
